import Cookies from "js-cookie";
import { getUserCoins } from "./apicalls/user";

export const getAuthToken = () => {
  return Cookies.get("accessToken");
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: token }),
  };
};

export const fetchWithAuth = async (url, options = {}) => {
  const token = getAuthToken();

  const config = {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: token }),
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      if (response.status === 401) {
        Cookies.remove("accessToken");
        Cookies.remove("user");
        window.location.href = "/login";
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateUserCoins = async () => {
  try {
    const response = await getUserCoins();
    if (response) {
      const totalCoins =
        response.total_coins !== undefined
          ? response.total_coins
          : response.coins !== undefined
            ? response.coins
            : 0;

      const storedUser = Cookies.get("user");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        user.total_coins = totalCoins;
        Cookies.set("user", JSON.stringify(user));
        window.dispatchEvent(new Event("user_data_updated"));
      }
    }
  } catch (e) {
    console.error("Error updating user coins", e);
  }
};

export const updateUserXP = (xpToAdd) => {
  const storedUser = Cookies.get("user");
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      const currentXP = Number(user.total_xp || 0);
      const addedXP = Number(xpToAdd || 0);
      user.total_xp = currentXP + addedXP;
      Cookies.set("user", JSON.stringify(user));
      window.dispatchEvent(new Event("user_data_updated"));
    } catch (e) {
      console.error("Error updating user XP", e);
    }
  }
};

export const checkIsAdmin = () => {
  const storedUser = Cookies.get("user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      return !!parsedUser.admin;
    } catch (error) {
      console.error("Failed to parse user from Cookies", error);
      return false;
    }
  }
  return false;
};

export const checkIsAiEvalEnabled = () => {
  const storedUser = Cookies.get("user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      return !!parsedUser.is_ai_eval_enabled;
    } catch (error) {
      console.error("Failed to parse user from Cookies", error);
      return false;
    }
  }
  return false;
};
